/**
 * External Imports
 */
import styled from 'styled-components';

export const CompHeaderContainer = styled.div`
  position: static;
  min-height: 86px;
  background: #f6f6f6;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.15rem 1rem;
  border-bottom: 1px solid #b0b0b0;
`;

export const DateRangeSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const HintSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 0.625rem;
  min-width: 10em;
`;

export const InputHeading = styled.div`
  display: inline-block;
  font-size: 0.9375rem;
  line-height: 22px;
`;

export const Range = styled.div`
  margin-right: 0.5em;
`;

export const StartEnd = styled.div`
  display: flex;
  padding-top: 4px;
`;
